import React from "react";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

const AlertDismissible = ({
  showInstructions,
  setShowInstructions,
  config,
}) => {
  return (
    <Alert style={{ opacity: 100 }} variant="primary" show={showInstructions}>
      <Alert.Heading>{config.title}</Alert.Heading>
      <p>{config.content}</p>
      <hr />
      <div className="d-flex justify-content-end">
        <Button
          onClick={() => {
            setShowInstructions(false);
            localStorage.setItem("posters-instructions", false);
          }}
          variant="outline-primary"
        >
          {config.button}
        </Button>
      </div>
    </Alert>
  );
};

export default AlertDismissible;
